var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantWebStatusBarFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.191,
    y: 0.801,
    width: 375.912,
    height: 12,
    rx: 6,
    fill: "#EAECF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.267,
    width: 376,
    height: 12,
    rx: 6,
    fill: "#EAECF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0.267,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#604DBC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.838,
    y: 3.267,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#fff",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 0.534,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#D05353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.282 3.815a.96.96 0 000 1.36l1.359 1.359-1.359 1.36a.96.96 0 101.359 1.358L189 7.893l1.359 1.36a.96.96 0 101.359-1.36l-1.359-1.36 1.359-1.358a.96.96 0 10-1.359-1.36L189 5.175l-1.359-1.36a.96.96 0 00-1.359 0z",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 366.215,
    y: 3.801,
    width: 6.407,
    height: 6.002,
    rx: 3.001,
    stroke: "#C4C9D9",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzc3IiBoZWlnaHQ9IjEzIiB2aWV3Qm94PSIwIDAgMzc3IDEzIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIwLjE5MTQwNiIgeT0iMC44MDA5MDMiIHdpZHRoPSIzNzUuOTEyIiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iI0VBRUNGNiIvPgo8cmVjdCB5PSIwLjI2Njk2OCIgd2lkdGg9IjM3NiIgaGVpZ2h0PSIxMiIgcng9IjYiIGZpbGw9IiNFQUVDRjYiLz4KPHJlY3QgeT0iMC4yNjY5NjgiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgcng9IjYiIGZpbGw9IiM2MDREQkMiLz4KPHJlY3QgeD0iMi44Mzc4OSIgeT0iMy4yNjY5NyIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxODMiIHk9IjAuNTMzOTM2IiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSI2IiBmaWxsPSIjRDA1MzUzIi8+CjxwYXRoIGQ9Ik0xODYuMjgyIDMuODE1NDVDMTg1LjkwNiA0LjE5MDggMTg1LjkwNiA0Ljc5OTMzIDE4Ni4yODIgNS4xNzQ2OUwxODcuNjQxIDYuNTMzOTRMMTg2LjI4MiA3Ljg5MzE4QzE4NS45MDYgOC4yNjg1MyAxODUuOTA2IDguODc3MDYgMTg2LjI4MiA5LjI1MjQyQzE4Ni42NTcgOS42Mjc3OCAxODcuMjY1IDkuNjI3NzcgMTg3LjY0MSA5LjI1MjQyTDE4OSA3Ljg5MzE4TDE5MC4zNTkgOS4yNTI0MkMxOTAuNzM1IDkuNjI3NzggMTkxLjM0MyA5LjYyNzc3IDE5MS43MTggOS4yNTI0MkMxOTIuMDk0IDguODc3MDcgMTkyLjA5NCA4LjI2ODU0IDE5MS43MTggNy44OTMxOEwxOTAuMzU5IDYuNTMzOTRMMTkxLjcxOCA1LjE3NDY5QzE5Mi4wOTQgNC43OTkzNCAxOTIuMDk0IDQuMTkwODEgMTkxLjcxOCAzLjgxNTQ1QzE5MS4zNDMgMy40NDAwOSAxOTAuNzM1IDMuNDQwMSAxOTAuMzU5IDMuODE1NDVMMTg5IDUuMTc0NjlMMTg3LjY0MSAzLjgxNTQ1QzE4Ny4yNjUgMy40NDAwOSAxODYuNjU3IDMuNDQwMSAxODYuMjgyIDMuODE1NDVaIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSIzNjYuMjE1IiB5PSIzLjgwMDkiIHdpZHRoPSI2LjQwNjc4IiBoZWlnaHQ9IjYuMDAyMTciIHJ4PSIzLjAwMTA5IiBzdHJva2U9IiNDNEM5RDkiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgInstantWebStatusBarFailed as ReactComponent };